import { notification } from "antd";
import axios, { AxiosError } from "axios";
import { translation } from "../i18n/translationConstant";
import { UserLoginSuccessResponse } from "../Models/Response/Authentication/Otp";
import { pauseLoader, startLoader } from "../redux/actions";
import store from "../redux/store";
import { getAccessToken } from "../Services/AuthenticationServices/AuthenticationServices";
import {
  getLocalStorageItem,
  localStorageConstants,
  setAccessToken,
  setPhoneNumber,
  setRefreshToken,
  setSessionId,
  setVuaId,
} from "../Services/LocalStorageServices";
import { QueryParams, Routes } from "./Constants/routes";
import { apiTimeout } from "./Constants/apiConstants";

const interceptor = (history: any, t: any) => {
  axios.defaults.baseURL =
    localStorage.getItem("isV1") === "true"
      ? process.env.REACT_APP_BASE_URL_V1
      : process.env.REACT_APP_BASE_URL;
  axios.interceptors.request.use(
    (request) => {
      store.dispatch(startLoader());
      if (request.data === undefined) {
        request.data = {};
      }
      request.headers = {
        ...request.headers,
        "Content-Type": "application/json",
      };

      if (
        getLocalStorageItem(localStorageConstants.accessToken) &&
        !request.url?.includes("public") &&
        !request.url?.includes("/User/forgetPassword")
      ) {
        request.headers = {
          ...request.headers,
          Authorization: `Bearer ${getLocalStorageItem(
            localStorageConstants.accessToken
          )}`,
        };
      }

      request.timeout = apiTimeout;

      return request;
    },
    (error) => {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  // Add a response interceptor
  axios.interceptors.response.use(
    // tslint:disable-next-line: only-arrow-functions
    function (response) {
      store.dispatch(pauseLoader());
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response;
    },
    // tslint:disable-next-line: only-arrow-functions
    function (error: AxiosError) {
      store.dispatch(pauseLoader());
      const originalRequest = error.config;
      if (originalRequest.url === "/public/user/refreshtoken") {
        return Promise.reject(error);
      }
      if (error.response?.status === 401) {
        if (
          originalRequest.url !== "/public/user/verify-otp" &&
          originalRequest.url !== "/public/user/login" &&
          originalRequest.url !== "/public/user/send-otp" &&
          originalRequest.url !== "/public/user/signup/verify" &&
          originalRequest.url !== "/public/user/login/pin"
        ) {
          return getAccessToken(
            getLocalStorageItem(localStorageConstants.refreshToken)
          )
            .then((res) => res.data)
            .then((res: UserLoginSuccessResponse) => {
              setAccessToken(res.access_token);
              return axios(originalRequest);
            })
            .catch((refreshTokenError) => {
              setAccessToken("");
              setPhoneNumber("");
              setRefreshToken("");
              setVuaId("");
              setSessionId("");
              notification.error({
                message: "Session Timeout",
                description: "",
                duration: 3,
              });
              history.push({
                pathname: Routes.login,
                search:
                  history.location.pathname !== Routes.login
                    ? `?${QueryParams.redirect}=${history.location.pathname}`
                    : undefined,
                state: { search: history.location.search },
              });
              return Promise.reject(refreshTokenError);
            });
        } else {
          notification.error({
            message: error.response?.data.errorCode
              ? error.response?.data.errorCode
              : t(translation.lblUnAuthorized),
            description: "",
            duration: 3,
          });
        }
      } else if (error.code === "ECONNABORTED") {
        notification.error({
          message: "Server Timeout",
          duration: 3,
        });
      } else {
        // notification.error({
        //   message: error.response?.data.errorCode
        //     ? error.response?.data.errorCode
        //     : "Your request cannot be processed at the moment. Please try again later.",
        //   description: error.response?.data.errorMsg
        //     ? error.response?.data.errorMsg
        //     : "",
        //   duration: 3,
        // });

        if (error.response?.data?.errorCode) {
          notification.error({
            message: error.response.data.errorCode,
            description: error.response.data.errorMsg || "",
            duration: 3,
          });
        }
        if (error.response?.data.redirectUrl) {
          window.location.replace(error.response?.data.redirectUrl);
        }
      }

      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error);
    }
  );
};
export default interceptor;
